import React from "react"
import { Box, Grid, Heading, Container } from "@theme-ui/components"
import RichContentStructuredText from "../richContentStructuredText"

const TitleAndBody = ({ block }) => {
  const { align = "right", content, background = "light" } = block
  const { title, subtitle, body } = block.content
  return (
    <Box
      sx={{
        backgroundColor: background ? background : "light",
        py: align !== "center" && [6, 9],
      }}
    >
      <Container>
        <Grid
          columns={[1, 1, align === "center" ? "1fr 1.8fr" : "1fr 1fr"]}
          gap={[32, 65]}
        >
          <Box>
            {title !== "EMPTY" && (
              <Heading
                as="h2"
                variant="h1"
                sx={{
                  fontWeight: "400",
                  fontSize: [6, 8],
                  color: background === "primary" ? "light" : "primary",
                }}
              >
                {title}
              </Heading>
            )}
          </Box>
          <Box
            sx={{
              p: { color: background === "primary" ? "light" : "inherit" },
              a: { color: background === "primary" ? "light" : null },
            }}
          >
            {subtitle && (
              <Heading
                color="dark"
                as="h2"
                variant="h3"
                sx={{
                  mt: [0, 0],
                  fontWeight: "300",
                  color: background === "primary" ? "light" : "inherit",
                  pb: [6],
                }}
              >
                {subtitle}
              </Heading>
            )}
            <RichContentStructuredText text={body} />
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default TitleAndBody
